<template>
  <div class="page-article-list__content">
    <div class="page-article-list__header">
      <app-articles-nav></app-articles-nav>
      <div class="page-article-list__search">
        <el-input size="mini" v-model="keyword" @keyup.enter.native="handleSearchByKeyword" placeholder="请输入关键词">
          <el-button type="primary" slot="append" icon="el-icon-search" @click="handleSearchByKeyword"></el-button>
        </el-input>
      </div>
    </div>
    <div class="page-article-list__body">
      <template v-if="publishArticle.total > 0">
        <app-articles>
          <app-articles-item
            v-for="item in publishArticle.list"
            :article="item"
            :key="item.id"
            @edit="handleArticleEdit"
            @delete="handleArticleDelete"
          ></app-articles-item>
        </app-articles>
        <template v-if="publishArticle.total > limit">
          <el-pagination
            :total="publishArticle.total"
            :page-size="limit"
            :current-page="offset + 1"
            layout="prev, pager, next"
            @current-change="handlePageChange"
            background
          ></el-pagination>
        </template>
      </template>
      <app-no-data v-else></app-no-data>
    </div>
  </div>
</template>

<script>
import AppArticlesNav from '@/components/AppArticlesNav'
import AppNoData from '@/components/AppNoData'
import { AppArticles, AppArticlesItem } from '@/components/AppArticles'

export default {
  name: 'PageArticleListPublish',
  components: {
    AppArticlesNav,
    AppNoData,
    AppArticles,
    AppArticlesItem
  },

  data () {
    return {
      keyword: '',
      offset: 0,
      limit: 10
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },
    publishArticle () {
      return this.$store.state.article.publishArticle
    }
  },

  created () {
    this.getArticles()
  },

  methods: {
    getArticles () {
      this.$store.dispatch('getArticles', {
        query: {
          query: this.keyword,
          status: [ 5 ],
          offset: this.offset * this.limit,
          limit: this.limit
        },
        params: {
          userId: this.user.id
        }
      })
    },

    resetPage () {
      this.offset = 0
    },

    handleSearchByKeyword () {
      this.resetPage()
      this.getArticles()
    },

    handlePageChange (page) {
      this.offset = --page
      this.getArticles()
    },

    handleArticleEdit (id) {
      this.$router.push({ name: 'ArticleEdit', query: { id } })
    },

    handleArticleDelete (id) {
      this.$confirm('此操作将删除该文章, 是否继续?', '提示', {
        type: 'warning',
        showClose: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.$store.dispatch('deleteArticle', {
          params: {
            userId: this.user.id,
            articleId: id
          }
        }).then(response => {
          this.getArticles()
          this.$message({
            type: 'success',
            message: '删除文章成功!'
          })
        })
      }).catch(() => {
        // No handle
      })
    }

  }
}
</script>
